import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import useLoyaltyCustomeHistory from "./useLoyaltyCustomeHistory";
import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";

const LoyaltyCustomeHistory = () => {
  const { isRefresh, setIsRefresh } = useLoyaltyCustomeHistory();
  const { setTerminalHeader } = useOutletContext();
  useEffect(() => {
    setTerminalHeader({
      title: "Customer History",
      description:
        "See who are your most loyal customers and how many points they have earned.",
    });
  }, []);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Customer History"
      description="Customer history"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
        >
          <secondaryComponents.CustomerHistoryTable
            isRefresh={isRefresh}
            setIsRefresh={setIsRefresh}
          />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default LoyaltyCustomeHistory;
